export default "__VITE_ASSET__CWMbgY2x__"